import {
  assetOnboardingUrl,
  customerAccessTransfer,
} from "src/api/smartChargingClients";
import {
  Alert,
  Box,
  Snackbar,
  SnackbarCloseReason,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "src/components/Displays/Text";
import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { MicroFrontendDetails, SESSION_KEYS } from "src/consts/session";

const Start = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("translation");
  const transferId = searchParams.get("tid") || "";
  const [msg, setMsg] = useState("");
  const [open, setOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [onboardingUrl, setOnboardingUrl] = useState("");

  const [, setCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );
  const [, setMicroFrontendDetails] = useSessionStorage<MicroFrontendDetails>(
    SESSION_KEYS.MICRO_FRONTEND_DETAILS,
  );
  const [getCustomerAccess] = useSessionStorage<string>(
    SESSION_KEYS.MFE_CUSTOMER_ACCESS,
  );

  const getCustomerAccessTransfer = useCallback(async () => {
    setIsLoading(true);
    try {
      const sessionTransferId = getCustomerAccess();

      if (sessionTransferId) {
        const url = await assetOnboardingUrl({
          xIsonCustomerToken: sessionTransferId,
        });
        setOnboardingUrl(url.onboardingUrl);
        setIsLoading(false);
        return;
      }

      const response = await customerAccessTransfer({
        payload: {
          tid: transferId,
        },
      });

      setCustomerAccess(response.access);
      setMicroFrontendDetails(response.microFrontendDetails);

      const url = await assetOnboardingUrl({
        xIsonCustomerToken: response.access,
      });
      setOnboardingUrl(url.onboardingUrl);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      const error = e as Error;
      setMsg(error.message ?? "");
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCustomerAccessTransfer();
  }, [getCustomerAccessTransfer]);

  const handleNextClick = () => {
    window.location.href = onboardingUrl;
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <Stack gap={5}>
      <Text
        text={t("page.addEvStart.pageTitle")}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Text
        text={t("page.addEvStart.pageSubTitle")}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Box>
        <PrimaryButton
          isLoading={isLoading}
          onClick={handleNextClick}
          text={t("page.addEvStart.nextBtnText")}
        />
      </Box>

      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert
          severity="error"
          variant="filled"
          onClose={handleClose}
          sx={{ width: "100%" }}
        >
          {msg}
        </Alert>
      </Snackbar>
    </Stack>
  );
};

export default Start;
